import { Box } from '@components/gassan-ui'
import { FC } from 'react'

type Props = {}

const Line: FC<Props> = () => {
  return (
    <Box
      position="absolute"
      width="1rem"
      left="calc(50% - .5rem)"
      height="95%"
      display={{ _: 'none', large: 'block' }}
    >
      <Box
        width="100%"
        position="absolute"
        background="linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);"
        height="10%"
      ></Box>
      <Box width={2} height="100%" backgroundColor="eagle" mx="auto" />
      <Box
        width="100%"
        position="absolute"
        bottom={0}
        background="linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);"
        height="10%"
      ></Box>
    </Box>
  )
}

export default Line
